import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import type { RouterContext } from '@/router';
import { TooltipProvider } from '@/components/ui/tooltip';

// createRootRouteWithContext, not createRootRoute: without it the router context is untyped.
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

// Auth lives above the router (in App.tsx) to feed the router context; the
// sidebar shell is scoped to `_app`, so `_auth` routes render bare here.
export function RootLayout() {
  return (
    <TooltipProvider>
      <Outlet />
      <TanStackRouterDevtools position='bottom-right' initialIsOpen={false} />
    </TooltipProvider>
  );
}
